<script lang="ts">
  import Modal from "$app/components/Modal.svelte"
  import FlywheelEntryForm from "./FlywheelEntryForm.svelte"
  import { SquarePen, Trash2, Menu, TriangleAlert } from "lucide-svelte"

  interface Props {
    flywheel_entry: FlywheelEntryType
    ondelete: (data: FlywheelEntryType) => void
  }

  let { flywheel_entry = $bindable(), ondelete }: Props = $props()

  let showDelete: boolean = $state(false)
</script>

{#if flywheel_entry._edit}
  <FlywheelEntryForm
    {flywheel_entry}
    onupdate={(data: FlywheelEntryType) => {
      flywheel_entry._edit = false
      flywheel_entry = data
    }}
    oncancel={() => (flywheel_entry._edit = false)}
  />
{:else}
  <div class="flex" class:bg-blue-50={showDelete}>
    <div
      class="px-2 w-8 flex items-center justify-center bg-blue-50 hover:bg-blue-100 border-r border-gray-100"
    >
      <Menu class="w-5 h-5 text-gray-500 hover:text-gray-900" />
    </div>
    <div class="px-4 py-3 w-full">
      <div class="flex justify-between items-center">
        <div class="flex-1 whitespace-nowrap text-lg font-medium text-gray-900">
          <span class="text-xs text-gray-600 mr-2"
            >{flywheel_entry.position}.</span
          >
          {flywheel_entry.title}
        </div>
        <div class="whitespace-nowrap text-right">
          <button
            class="text-gray-500 hover:text-blue-500"
            title="Edit"
            onclick={() => (flywheel_entry._edit = true)}
            ><SquarePen class="w-5 h-5" /></button
          >
          <button
            type="button"
            class="pl-4 text-yellow-700"
            title="Archive department"
            onclick={() => {
              flywheel_entry._selected = true
              showDelete = true
            }}
          >
            <Trash2 class="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  </div>
{/if}

<Modal bind:open={showDelete}>
  <div class="p-4 text-center">
    <p>
      Are you sure you want to <span class="font-bold">delete</span> the selected
      flywheel entry?
    </p>

    <TriangleAlert
      class="size-20 mx-auto mt-4 mb-2 text-yellow-400"
      aria-hidden="true"
    />

    <div class="mt-4">
      <button
        class="btn btn-primary btn-lg font-semibold"
        onclick={() => {
          ondelete(flywheel_entry)
        }}
      >
        Yes, Delete
      </button>
      &nbsp;
      <button
        class="btn btn-secondary btn-lg font-semibold"
        onclick={() => (showDelete = false)}
      >
        Cancel
      </button>
    </div>
  </div>
</Modal>
